import { Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterModule, Router } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { UserService } from '../../services/user.service';
import { SITE_NAME } from '../../types';

@Component({
  selector: 'app-sitenav-content',
  imports: [    MatIcon, RouterModule, MatSidenavModule, MatListModule, CommonModule
    ],
  templateUrl: './sitenav-content.html',
  styleUrl: './sitenav-content.scss'
})
export class SitenavContent {
  userService = inject(UserService);
  router = inject(Router);
  siteName = SITE_NAME;

    logout() {
    this.userService.logout();
    this.router.navigate(['/messages']);
  }

}
